export class GoogleTagManagerVanilla {
    constructor(options = {}) {
        this._options = options;
    }

    fire(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ zoma_data: undefined, job: undefined });
        window.dataLayer.push(event);
    }
}

export const GoogleTagManagerVuePlugin = {
    install: function (Vue, options) {
        Vue.prototype.$gtag = new GoogleTagManagerVanilla(options);
    }
}
